// src/app/core/core.module.ts
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha-2';
import {CurrencyPipe} from '@angular/common';

// Core services
import {SEOService} from './services/seo.service';
import {Globals} from './services/globals';
import {TrackingService} from './services/tracking.service';
import {WindowReferenceService} from './services/window-reference.service';
import {DataLayerService} from './services/data-layer.service';

@NgModule({
  declarations: [],
  imports: [
    // Angular modules
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,

    // Third-party modules
    RecaptchaV3Module,
  ],
  providers: [
    // Global singleton services
    CurrencyPipe,
    SEOService,
    Globals,
    TrackingService,
    WindowReferenceService,
    DataLayerService,

    // RecaptchaV3 configuration
    {provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LfsyZ4qAAAAAPR4FS0hy-oB5ZRfJCHD9vm0AvFj'},
  ],
  exports: [
    // Modules needed throughout the app
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only.'
      );
    }
  }
}
